import {
  UserInfos,
  UserSecurity,
} from '@/components';

export default {
  name: 'User',
  components: {
    UserInfos,
    UserSecurity,
  },
};
